import { render, staticRenderFns } from "./PhoneOrEmailInput.vue?vue&type=template&id=5c6fc588&scoped=true&"
import script from "./PhoneOrEmailInput.vue?vue&type=script&lang=js&"
export * from "./PhoneOrEmailInput.vue?vue&type=script&lang=js&"
import style0 from "./PhoneOrEmailInput.vue?vue&type=style&index=0&id=5c6fc588&prod&lang=scss&scoped=true&"
import style1 from "./PhoneOrEmailInput.vue?vue&type=style&index=1&id=5c6fc588&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fc588",
  null
  
)

export default component.exports